<template>
  <div class="trainers-page">
    <br><!-- NIČ VIAC TU NEBUDE, iba zavolanie komponentu -->
    <TrainersSection :trainers="trainers" />
  </div>
</template>

<script setup>
import TrainersSection from '@/components/TrainersSection.vue'
import { ref } from 'vue'

const trainers = ref([
  { name: 'Arben', image: require('@/assets/images/5.webp') },
  { name: 'Soňa', image: require('@/assets/images/sona-rusenova.webp') },
  { name: 'Lukáš', image: require('@/assets/images/8.webp') },
  { name: 'Klaudia', image: require('@/assets/images/2.webp') },
  { name: 'Andrej', image: require('@/assets/images/7.webp') },
  { name: 'Stefi', image: require('@/assets/images/3.webp') },
  { name: 'Mário', image: require('@/assets/images/mario-vesely.webp') },
  { name: 'Eliška', image: require('@/assets/images/6.webp') },
  { name: 'Samuel', image: require('@/assets/images/samuel-cukan.webp') },
  { name: 'Zuzana', image: require('@/assets/images/zuz-pataky.webp') },
])
</script>

<style scoped>
.trainers-page {
  padding: 2rem;
}
</style>
